import {useParams} from "react-router-dom";

export const useGetUniSlug = () => {
    const {universitySlug} = useParams<{universitySlug: string}>();

    const getUniSlug = () => {
        return universitySlug;
    };

    return {getUniSlug};
};
